export class PaymentService {
    static redirectToPaymentGateway({
        entityId,
        paymentType,
        returnUrl,
        lang,
        title,
        isOnline,
        anonymousUserId
    }) {
        const UMBRACOURL = (process.env.REACT_APP_UMBRACO || "").replace(/\/+$/, "");
        let url = `${UMBRACOURL}/BackofficePayment/PaymentGetway?entityId=${entityId}&paymentType=${paymentType}`;
        
        const userId = localStorage.getItem("EAHSUserID");
        if (userId) {
            url += `&userId=${userId}`;
        }

        if (returnUrl) {
            url += `&returnUrl=${encodeURIComponent(returnUrl)}`;
        }
        
        if (lang) {
            url += `&lang=${lang}`;
        }

        if (title) {
            url += `&title=${encodeURIComponent(title)}`;
        }
        
        if (isOnline !== undefined) {
            url += `&isOnline=${isOnline ? 'yes' : 'no'}`;
        }
        
        if (anonymousUserId) {
            url += `&anonymousUserId=${anonymousUserId}`;
        }

        window.location.href = url;
    }
}
